import { render, staticRenderFns } from "./TagsPerson.vue?vue&type=template&id=5757a7fc&"
import script from "./TagsPerson.vue?vue&type=script&lang=js&"
export * from "./TagsPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports